import { toast } from "react-hot-toast";
import { classNames } from "./classnames";
import { Toast } from "@/shared/components/molecules/Toast";
import {
  faCheckCircle,
  faExclamationCircle,
  faInfoCircle,
  faWarning,
} from "@fortawesome/free-solid-svg-icons";

export const toasts:any = {
  message: (title: string, body: string, image: string) =>
    toast.custom(
      (t) => (
        <Toast
          t={t}
          title={title}
          body={body}
          image={image}
          variant="primary"
        />
      ),
      { position: "top-right" }
    ),
  success: (title: string, body: string) =>
    toast.custom(
      (t) => (
        <Toast
          t={t}
          title={title}
          body={body}
          icon={faCheckCircle}
          variant="success"
        />
      ),
      { position: "top-right" }
    ),
  danger: (title: string, body: string) =>
    toast.custom(
      (t) => (
        <Toast
          t={t}
          title={title}
          body={body}
          icon={faExclamationCircle}
          variant="danger"
        />
      ),
      { position: "top-right" }
    ),
  warning: (title: string, body: string) =>
    toast.custom(
      (t) => (
        <Toast
          t={t}
          title={title}
          body={body}
          icon={faWarning}
          variant="warning"
        />
      ),
      { position: "top-right" }
    ),
  info: (title: string, body: string) =>
    toast.custom(
      (t) => (
        <Toast
          t={t}
          title={title}
          body={body}
          icon={faInfoCircle}
          variant="info"
        />
      ),
      { position: "top-right" }
    ),
};
